import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import LineEdit from '@app/pages/customer/LineEdit/LineEdit.tsx';

const CreateLinePage: React.FC = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout title={tr('LineEdit.pageTitleNew', 'Nová linka')} oneOfPermission={[PermissionTypesEnum.PERMISSION_TEMPLATE]}>
      <LineEdit />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CreateLinePage);
